import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import FormHandler from "../../shared/utils/FormHandler";
import FeatherIcon from "feather-icons-react";
import {useTranslation} from "react-i18next";
import {createCorporate, getAccountUsers, updateCorporate} from "../../utils/mainServices";
import {toast} from "react-toastify";
import {toggleLoader} from "../../shared/actions/setting";
import { validateFormCorporate } from "../../utils/validation";

const FormCorporate = ({selectedCorporate, onClose, formType}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const [allAccount, setAllAccount] = useState([]);
  const [formErr, setFormErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleOnBlur,
    initForm,
  } = FormHandler(updateCorporateDetails, validateFormCorporate);

  function updateCorporateDetails() {
    setIsLoading(true);
  }

  // Initialize form when the modal is opened
  useEffect(() => { 
    initForm({
      accountId: selectedCorporate?.accountId || "",
      name: selectedCorporate?.name || "",
      contactName: selectedCorporate?.contactName || "",
      contactEmail: selectedCorporate?.contactEmail || "",
      contactAddress: selectedCorporate?.contactAddress || "",
      contactPhoneNumber: selectedCorporate?.contactPhoneNumber || "",
    });       
  }, [selectedCorporate]);

  //Fetch accounts from API
  useEffect(() => {
    const fetchAllAccounts = async () => {
      try {
        const AccountData = await getAccountUsers();
        setAllAccount(AccountData.content || []);
      } catch (error) {
        console.error("Error fetching roles:", error);
        toast.error("Failed to load roles");
      }
    };
    fetchAllAccounts();
  }, []);

  const resetForm = (state) => {
    onClose(state);
    initForm({});
    setFormErr("");
  };

 //update the corporate details
  useEffect(() => {
    if ( formType ==="edit") {
      const updateCorporateDetails = async () => {
        dispatch(toggleLoader(true));
        try {        
          values.id = selectedCorporate.id;
          await updateCorporate(values, selectedCorporate.id);
          resetForm(true);
          toast.success("Corporate details updated successfully");
        } catch (error) {
          console.error("Error updating corporate details:", error);
          toast.error("Failed to update corporate details");
        } finally {
          dispatch(toggleLoader(false));
          setIsLoading(false);
        }
      };
    
      if (isLoading) {
        updateCorporateDetails();
      }
    } else {
      const createCorporateDetails = async () => {
        dispatch(toggleLoader(true));
        try {        
          await createCorporate(values);
          resetForm(true);
          toast.success("Corporate created successfully");
        } catch (error) {
          console.error("Error create corporate:", error);
          toast.error("Failed to create corporate");
        } finally {
          dispatch(toggleLoader(false));
          setIsLoading(false);
        }
      };
    
      if (isLoading) {
        createCorporateDetails();
      }
    }
  }, [isLoading]);
  
  

  return (
    <div className={`sa-popup-bg`}>
      <div className="sa-popup">
        <form onSubmit={handleSubmit} className="sa-modal-box-style" noValidate>
          <div className="sa-popup-header">
            <span className="sa-model-heading">
              {formType === "edit" ? t("title.EDIT_CORPORATE") : t("title.CREATE_CORPORATE")}
            </span>
            <div className="sa-popup-close-icon" onClick={() => resetForm(false)}>
              <FeatherIcon className="sa-modal-close-icon" icon="x"/>
            </div>
          </div>
          <div className="sa-popup-content">
              <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="accountId">Account ID</label>
                <select
                  className={`form-control ${errors.accountId && "warning-input"}`}
                  onBlur={handleOnBlur}
                  onChange={handleChange}
                  value={values.accountId || ""}
                  name="accountId"
                  id="accountId"
                >
                  <option hidden value="">
                    {t("placeHolder.SELECT_USER_ROLE")}
                  </option>
                  {allAccount.map((account, index) => (
                    <option key={index} value={account.id}>
                      {account.name}
                    </option>
                  ))}
                </select>
                {errors.accountId && <p className="warning-input-msg">{errors.accountId}</p>}
              </div>
              </div>
              <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className={`form-control ${errors.name && "warning-input"}`}
                  onBlur={handleOnBlur}
                  onChange={handleChange}
                  value={values.name || ""}
                  name="name"
                  id="name"
                  placeholder="Enter your name"
                />
                {errors.name && <p className="warning-input-msg">{errors.name}</p>}
              </div>
              </div>
              <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="contactName">Contact Name</label>
                <input
                  type="text"
                  className={`form-control ${errors.contactName && "warning-input"}`}
                  onBlur={handleOnBlur}
                  onChange={handleChange}
                  value={values.contactName || ""}
                  name="contactName"
                  id="contactName"
                  placeholder="Enter your Contact Name"
                />
                {errors.contactName && <p className="warning-input-msg">{errors.contactName}</p>}
              </div>
              </div>
              <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="contactEmail">Contact Email</label>
                <input
                  type="text"
                  className={`form-control ${errors.contactEmail && "warning-input"}`}
                  onBlur={handleOnBlur}
                  onChange={handleChange}
                  value={values.contactEmail || ""}
                  name="contactEmail"
                  id="contactEmail"
                  placeholder="Enter your Contact Email"
                />
                {errors.contactEmail && <p className="warning-input-msg">{errors.contactEmail}</p>}
              </div>
              </div>
              <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="contactAddress">Contact Address</label>
                <input
                  type="text"
                  className={`form-control ${errors.contactAddress && "warning-input"}`}
                  onBlur={handleOnBlur}
                  onChange={handleChange}
                  value={values.contactAddress || ""}
                  name="contactAddress"
                  id="contactAddress"
                  placeholder="Enter your Contact Address"
                />
                {errors.contactAddress && <p className="warning-input-msg">{errors.contactAddress}</p>}
              </div>
              </div>
              <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="contactPhoneNumber">Contact Phone Number</label>
                <input
                  type="text"
                  className={`form-control ${errors.contactPhoneNumber && "warning-input"}`}
                  onBlur={handleOnBlur}
                  onChange={handleChange}
                  value={values.contactPhoneNumber || ""}
                  name="contactPhoneNumber"
                  id="contactPhoneNumber"
                  placeholder="Enter your Contact Phone Number"
                />
                {errors.contactPhoneNumber && <p className="warning-input-msg">{errors.contactPhoneNumber}</p>}
              </div>
              </div>             
            </div>
          {formErr && <div className="login-warning-msg">{formErr}</div>}
          <div className="sa-popup-btn" style={{ display: "flex", justifyContent: "flex-end" }}>
            <button type="submit" className="sa-popup-secondary-btn-style">      
              {formType === "edit" ? (t("button.UPDATE")) : (t("button.CREATE"))}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormCorporate;